import React, { useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { EllipsisHorizontalIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { ADMIN_NAV_ITEMS, getAdminActiveItem, PRIMARY_ADMIN_MOBILE_KEYS } from './adminNavigation';

const AdminTopNav: React.FC = () => {
  const location = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);
  const activeItem = getAdminActiveItem(location.pathname);
  const primaryItems = useMemo(
    () => ADMIN_NAV_ITEMS.filter((item) => PRIMARY_ADMIN_MOBILE_KEYS.includes(item.key)),
    []
  );
  const overflowItems = useMemo(
    () => ADMIN_NAV_ITEMS.filter((item) => !PRIMARY_ADMIN_MOBILE_KEYS.includes(item.key)),
    []
  );
  const isOverflowActive = !PRIMARY_ADMIN_MOBILE_KEYS.includes(activeItem.key);
  const commonLinkClass =
    'flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-md px-1 py-1 text-[10px] font-medium leading-tight transition-colors duration-150';
  const activeLinkClass = 'bg-ratuj-300/18 text-ratuj-200 ring-1 ring-ratuj-300/22';
  const inactiveLinkClass = 'text-primary-light-400 hover:text-primary-light-100';

  return (
    <>
      {moreOpen && (
        <div className="fixed inset-x-2 bottom-[calc(4.35rem+env(safe-area-inset-bottom))] z-[55] rounded-lg border border-primary-dark-300/42 bg-primary-dark-200/96 p-2 shadow-dropdown backdrop-blur-sm md:hidden">
          <div className="mb-1 flex items-center justify-between px-1">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-primary-light-400">
              Pozostałe moduły
            </p>
            <button
              type="button"
              onClick={() => setMoreOpen(false)}
              className="inline-flex h-8 w-8 items-center justify-center rounded-md text-primary-light-400 hover:bg-primary-dark-100/55 hover:text-primary-light-100"
              aria-label="Zamknij menu admina"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-1">
            {overflowItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.key}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMoreOpen(false)}
                  className={({ isActive }) =>
                    `flex min-h-[42px] min-w-0 items-center gap-2 rounded-md px-2 text-xs font-medium transition-colors ${
                      isActive
                        ? 'bg-ratuj-300/16 text-ratuj-200'
                        : 'text-primary-light-300 hover:bg-primary-dark-100/55 hover:text-primary-light-100'
                    }`
                  }
                >
                  <Icon className="h-4 w-4 shrink-0" />
                  <span className="truncate">{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      )}

      <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-primary-dark-300/42 bg-primary-dark-200/94 px-1 pt-1.5 backdrop-blur-sm md:hidden">
        <div className="grid grid-cols-5 gap-1 pb-[max(env(safe-area-inset-bottom),0.5rem)]">
          {primaryItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.key}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `${commonLinkClass} ${isActive ? activeLinkClass : inactiveLinkClass}`
                }
              >
                <Icon className="h-5 w-5 flex-shrink-0" />
                <span className="truncate">{item.mobileLabel}</span>
              </NavLink>
            );
          })}
          <button
            type="button"
            onClick={() => setMoreOpen((value) => !value)}
            className={`${commonLinkClass} ${
              isOverflowActive || moreOpen ? activeLinkClass : inactiveLinkClass
            }`}
            aria-expanded={moreOpen}
            aria-label="Pozostałe moduły admina"
          >
            <EllipsisHorizontalIcon className="h-5 w-5 flex-shrink-0" />
            <span className="truncate">{isOverflowActive ? activeItem.mobileLabel : 'Więcej'}</span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default AdminTopNav;
